/**
 * @fileoverview Custom hook for accessing filter context.
 * @module shared/hooks/useFilter
 */

import { useContext } from 'react'
import { FilterContext, FilterContextType } from '@/shared/context/FilterContext'

/**
 * Custom hook to access filter context.
 *
 * @returns Filter context value
 * @throws Error if used outside FilterProvider
 * @example
 * ```tsx
 * const { startDate, endDate, setDateRange } = useFilter();
 * ```
 */
export function useFilter(): FilterContextType {
  const context = useContext(FilterContext)
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider')
  }
  return context
}
